import { styled } from '@mui/system';
import { Paper, Typography } from '@mui/material';
import { colors } from '../../../../../constants/theme';

export const ContentPaper = styled(Paper)(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '50px',
  background: colors.iconBackground,
  borderRadius: '40px',
  border: '10px solid #FFFFFF',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: 1000,
  minHeight: 420,
  boxSizing: 'border-box',
  [theme.breakpoints.down('xl')]: {
    maxWidth: 920,
    minHeight: 400,
  },
  [theme.breakpoints.down('lg')]: {
    maxWidth: 860,
    minHeight: 360,
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: 720,
    minHeight: 320,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: 560,
    minHeight: 280,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '32px',
  whiteSpace: 'pre-line',
  letterSpacing: '-.4px',
  textAlign: 'center',
  lineHeight: '50px',
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
  },
}));

export const BoldText = styled('span')({
  fontWeight: 500,
});
